import { useEffect, useRef, useState } from 'react';

export const useIsOverflowing = <T extends HTMLElement>({ value }: { value: unknown }) => {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    setIsOverflowing(el.scrollWidth > el.clientWidth);
  }, [value]);

  return { ref, isOverflowing };
};
